import React from 'react';
import { ButtonTheme, Placement } from '@philips-internal/oswald-ui-constants';
import { classNames, isEnumValid } from '@philips-internal/oswald-ui-utils';
import { useIsTouchableDevice } from '../../../../../hooks/use-is-touchable-device.js';
import { Button } from '../../../../button/button.js';
import { WizardMode } from '../../wizard-constants.js';
import { WizardBulletTrail } from '../wizard-bullet-trail/wizard-bullet-trail.js';
import './wizard-actions.css';
function isCurrentStepFirst(currentStepMetadataProps, stepsMetadata) {
    if (stepsMetadata.length <= 0) {
        return false;
    }
    const { identifier } = currentStepMetadataProps;
    return identifier === stepsMetadata[0].properties.identifier;
}
function ConfirmButton(props) {
    const { done } = props.currentStepMetadataProps;
    return (React.createElement(Button, { className: "c-wizard-actions__confirm-button", enabled: !props.readOnly && done, key: "confirm-steps", onClick: () => props.onSubmit(), value: props.confirmExpression }));
}
function NextButton(props) {
    const { done, identifier, readOnly: stepReadOnly } = props.currentStepMetadataProps;
    const readOnly = props.readOnly ? props.readOnly : stepReadOnly;
    return (React.createElement(Button, { className: "c-wizard-actions__next-button", enabled: readOnly || done, icon: "/static/assets/components/DLS_NavigationRight.svg", iconPlacement: Placement.RIGHT, key: "next-step", noPadding: true, onClick: () => props.onNextStep(identifier), theme: ButtonTheme.QUIET_EMPHASIS, value: props.nextStepExpression }));
}
function PreviousButton(props) {
    const isFirstStep = isCurrentStepFirst(props.currentStepMetadataProps, props.stepsMetadata);
    return (React.createElement(Button, { className: "c-wizard-actions__previous-button", enabled: !isFirstStep, icon: "/static/assets/components/DLS_NavigationLeft.svg", iconPlacement: Placement.LEFT, key: "previous-step", noPadding: true, onClick: () => props.onPreviousStep(), theme: ButtonTheme.QUIET_EMPHASIS, value: props.prevStepExpression }));
}
function WizardActions(props) {
    const { done, identifier, last } = props.currentStepMetadataProps;
    const isTouchableDevice = useIsTouchableDevice();
    const currentStepIndex = props.stepsMetadata.findIndex(({ properties }) => properties.identifier === identifier);
    const className = classNames({
        'c-wizard-actions': true,
        'c-wizard-actions--current-step-done': done,
        'c-wizard-actions--no-dots': !props.showTrail,
        'c-wizard-actions--touchable-device': isTouchableDevice,
        [`c-wizard-actions--${props.mode}`]: isEnumValid(WizardMode, props.mode),
    });
    return (React.createElement("div", { className: className },
        React.createElement(PreviousButton, { currentStepMetadataProps: props.currentStepMetadataProps, onPreviousStep: props.onPreviousStep, prevStepExpression: props.prevStepExpression, stepsMetadata: props.stepsMetadata }),
        React.createElement(WizardBulletTrail, { currentStepIndex: currentStepIndex, isCurrentStepDone: done, length: props.stepsMetadata.length, onClick: props.onBulletTrailClick, showTrail: props.showTrail }),
        !last ? (React.createElement(NextButton, { currentStepMetadataProps: props.currentStepMetadataProps, nextStepExpression: props.nextStepExpression, onNextStep: props.onNextStep, readOnly: props.readOnly })) : (React.createElement(ConfirmButton, { confirmExpression: props.confirmExpression, currentStepMetadataProps: props.currentStepMetadataProps, onSubmit: props.onSubmit, readOnly: props.readOnly }))));
}
export { WizardActions, };
//# sourceMappingURL=wizard-actions.js.map